<template>
  <div>
    <h3>
      <i class="fa fa-home"></i> {{ $t('word.organisation_dashboard') }}
    </h3>
    <v-alert
      v-if="!org.isVerified || !org.is_active"
      style-type="warning"
      text="sentence.organisation_not_verified"
      icon="exclamation-circle"
    />

    <v-timeline-chart
      v-if="researches"
      :researches="researches"
    />

    <ul class="nav nav-pills nav-justified mb-3" v-if="statistics">
      <li
        v-for="type in ['tv', 'radio', 'ooh']"
        :key="type"
        class="nav-item"
      >
        <a
          class="nav-link"
          :class="[commercialType === type ? `active bg-${type}` : '']"
          @click="commercialType = type"
          href="javascript:void(0)"
        >
          {{ $tc(`word.${type}_commercial`, 2) }}
          <i
            class="badge badge-primary badge-pill"
            :class="[`bg-${type}`]"
          >
            {{ statistics.researches_count[type] }}
          </i>
        </a>
      </li>
    </ul>
    <div class="row" v-if="!!statistics">
      <div class="col-lg-3 mb-3">
        <v-statistics-card
          text="word.commercials"
          type="warning"
          icon="play-circle"
          :statistic="getStatistic('researches_count')"
        />
      </div>
      <div class="col-lg-3 mb-3">
        <v-statistics-card
          :text="commercialType === 'radio' ? 'word.heard' : 'word.seen'"
          type="danger"
          icon="eye"
          :statistic="getStatistic('sessions_seen_count')"
        />
      </div>
      <div class="col-lg-3 mb-3">
        <v-statistics-card
          text="phrase.number_of_reviews"
          type="info"
          icon="check-square"
          :statistic="getStatistic('sessions_total_count')"
        />
      </div>
      <div class="col-lg-3 mb-3">
        <v-statistics-card
          text="phrase.profile_since"
          type="success"
          icon="calendar-day"
          :animated="false"
          :statistic="stringToPrettyDate(org.created_at)"
        />
      </div>
    </div>
    <v-commercial-research-card-list
      :organisation-slug="org.slug"
      :commercial-type="commercialType"
      :researches="researches || []"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Alert from '@/common/components/Alert.vue';
import CommercialResearchCardList from '@/organisation/components/CommercialResearchCardList.vue';
import StatisticCard from '@/common/components/StatisticCard.vue';
import { fetchOrganisationStatistics, fetchResearches } from '@/organisation/api';
import { stringToPrettyDate } from '@/common/utils/formatting';
import TimelineChart from '@/organisation/components/dashboard/TimelineChart.vue';

export default {
  name: 'Dashboard',
  components: {
    'v-alert': Alert,
    'v-statistics-card': StatisticCard,
    'v-commercial-research-card-list': CommercialResearchCardList,
    'v-timeline-chart': TimelineChart,
  },
  data() {
    return {
      commercialType: 'tv',
      researches: null,
      statistics: null,
    };
  },
  computed: {
    ...mapGetters(['org']),
  },
  methods: {
    stringToPrettyDate,
    getStatistic(statProp) {
      if (this.statistics) {
        return this.statistics[statProp][this.commercialType];
      }
      return 0;
    },
    getPicture(picturePath) {
      // eslint-disable-next-line global-require
      return `url('${picturePath || require('@/common/assets/img/anonymous.svg')}')`;
    },
    async fetchOrganisationStatistics() {
      const response = await fetchOrganisationStatistics(
        this.org.slug, { commercial_type: this.commercialType },
      );
      this.statistics = response.data;
    },
    async fetchResearches() {
      const response = await fetchResearches(this.org.slug);
      this.researches = response.data;
    },
  },
  created() {
    this.fetchOrganisationStatistics();
    this.fetchResearches();
  },
};
</script>
